import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

class Form77Service {
  async listTim(params: any = {}) {
    const response = await http
      .getDataParam("/tim-penguji-kesehatan", { params })
      .catch(err => {
        ErrorAlert.showErrorAlert(err);
        return Promise.reject(err);
      });
    return response.data;
  }

  async findTim(id: number) {
    const response = await http
      .getData(`/tim-penguji-kesehatan/${id}`)
      .catch(err => {
        ErrorAlert.showErrorAlert(err);
        return Promise.reject(err);
      });
    return response.data;
  }

  async createTim(data: any) {
    const response = await http
      .postData("/tim-penguji-kesehatan", data)
      .catch(err => {
        ErrorAlert.showErrorAlert(err);
        return Promise.reject(err);
      });
    return response.data;
  }

  async updateTim(id: number, data: any) {
    const response = await http
      .putData(`/tim-penguji-kesehatan/${id}`, data)
      .catch(err => {
        ErrorAlert.showErrorAlert(err);
        return Promise.reject(err);
      });
    return response.data;
  }

  async destroyTim(id: number) {
    const response = await http
      .deleteData(`/tim-penguji-kesehatan/${id}`)
      .catch(err => {
        ErrorAlert.showErrorAlert(err);
        return Promise.reject(err);
      });
    return response.data;
  }

  async cariDokter(term: string) {
    const response = await http
      .getDataParam("/tim-penguji-kesehatan/cari-dokter", { params: { term } })
      .catch(err => {
        ErrorAlert.showErrorAlert(err);
        return Promise.reject(err);
      });
    return response.data;
  }

  async signatures(id: number) {
    const response = await http
      .getData(`/form77/${id}/signatures`)
      .catch(err => {
        ErrorAlert.showErrorAlert(err);
        return Promise.reject(err);
      });
    return response.data;
  }

  async signMember(id: number, password: string) {
    const response = await http
      .postData(`/form77/${id}/sign`, { password })
      .catch(err => {
        ErrorAlert.showErrorAlert(err);
        return Promise.reject(err);
      });
    return response.data;
  }
}

export default new Form77Service();
